import MComponent from '../Toolkit/Components/Component';
import {withMsal, WithMsalProps} from '@azure/msal-react';
import WithRouterProps from '../Toolkit/WithRouterProps';
import MPage, {MPageProps} from '../Toolkit/Components/Shell/Page';
import MTable, {MTableProps} from '../Toolkit/Components/Controls/Table';
import {Notice, NoticeReplyMulti} from '../Api/NoticeTypes';
import NSwagAdapter from '../Toolkit/Api/NSwagAdapter';
import {NoticeClient} from '../Api/NoticeClients';
import MNSwagClientConfiguration from '../Toolkit/Api/NSwagClientConfiguration';
import SafeDigAccessTokenProvider from '../Api/SafeDigAccessTokenProvider';
import React, {createRef, ReactElement, RefObject} from 'react';
import WithRouter from '../Toolkit/WithRouter';
import MToolbar from '../Toolkit/Components/Controls/Toolbar';
import MButton from '../Toolkit/Components/Controls/Button';
import {MNewIconName, MOpenIconName} from '../Toolkit/Icons';
import MSpacer from '../Toolkit/Components/Controls/Spacer';
import {DataTable, DataTableExportFunctionParams} from 'primereact/datatable';
import {FilterMatchMode, FilterService} from 'primereact/api';
import {Column} from 'primereact/column';
import EnumContext from '../Context/enum-context';
import {Calendar} from 'primereact/calendar';
import {MDropDownItem} from '../Toolkit/Components/Controls/DropDownOption';
import MMultiDropDown from '../Toolkit/Components/Controls/MultiDropDown';
import StatusIndicator from './Components/StatusIndicator';
import {ExcelIconName, GotoIconName} from './SafeDigConstants';
import MDropDown from '../Toolkit/Components/Controls/DropDown';
import {MNullable} from '../Toolkit/Utils';

type NoticeRow = {
    notice: Notice;
}

type Props = WithMsalProps & WithRouterProps & {};

/** */
type State = {
    page: MPageProps;
    table: MTableProps<NoticeRow>;
    selectedRow?: NoticeRow;
}

class ListNoticesPage extends MComponent<Props, State> {
    static contextType = EnumContext;
    context!: React.ContextType<typeof EnumContext>;

    private readonly m_noticeClient: NSwagAdapter<NoticeClient>;
    private readonly m_datatableRef: RefObject<DataTable>;
    private m_filter = 0;

    public constructor(props: Props) {
        super(props);

        this.bindMethods();

        this.m_noticeClient = new NSwagAdapter<NoticeClient>(new NoticeClient(
            new MNSwagClientConfiguration(process.env.REACT_APP_SAFEDIGS_API_KEY!,
                new SafeDigAccessTokenProvider(this.props.msalContext))));
        this.m_datatableRef = createRef<DataTable>();

        this.initializeState();
    }

    private bindMethods(): void {
        this.new_Click = this.new_Click.bind(this);
        this.open_Click = this.open_Click.bind(this);
        this.registrations_Click = this.registrations_Click.bind(this);
        this.contacts_Click = this.contacts_Click.bind(this);
        this.safedigs_Click = this.safedigs_Click.bind(this);
        this.table_onSelectionChange = this.table_onSelectionChange.bind(this);
        this.filter_onSelectionChange = this.filter_onSelectionChange.bind(this);
        this.page_onLoadData = this.page_onLoadData.bind(this);
        this.isOpenButtonDisabled = this.isOpenButtonDisabled.bind(this);
        this.getToolbarTemplate = this.getToolbarTemplate.bind(this);
        this.export_Click = this.export_Click.bind(this);
        this.exportFunction = this.exportFunction.bind(this);
    }

    private initializeState(): void {
        //  Page
        const page: MPageProps = {
            locked: false
        };

        //  Table
        const table: MTableProps<NoticeRow> = {
            exportName: 'Notices',
            rowData: [],
            filters: {
                'notice.header.odinId': {
                    value: null,
                    matchMode: FilterMatchMode.CONTAINS
                },
                'notice.detail.tmType': {
                    value: null,
                    matchMode: FilterMatchMode.CUSTOM
                },
                'notice.detail.address1': {
                    value: null,
                    matchMode: FilterMatchMode.CONTAINS
                },
                'notice.detail.subResource': {
                    value: null,
                    matchMode: FilterMatchMode.IN
                },
                'notice.detail.permitType': {
                    value: null,
                    matchMode: FilterMatchMode.IN
                },
                'notice.detail.startDate': {
                    value: null,
                    matchMode: FilterMatchMode.DATE_IS
                },
                'notice.detail.endDate': {
                    value: null,
                    matchMode: FilterMatchMode.DATE_IS
                },
                'notice.detail.permitNumber': {
                    value: null,
                    matchMode: FilterMatchMode.CONTAINS
                },
                'notice.detail.submissionDate': {
                    value: null,
                    matchMode: FilterMatchMode.DATE_IS
                },
                'notice.detail.permitStatus': {
                    value: null,
                    matchMode: FilterMatchMode.IN
                }
            }
        };

        this.state = {
            page: page,
            table: table,
            selectedRow: undefined,
        };
    }

    private isOpenButtonDisabled(): boolean {
        return this.state.selectedRow === undefined;
    }

    private new_Click(): void {
        this.props.navigate('/notices/create/-1/-1/0');
    }

    private open_Click(): void {
        this.props.navigate(`/notices/${this.state.selectedRow!.notice.header!.id}`);
    }

    private exportFunction(e : DataTableExportFunctionParams){
        if(e.field === "notice.detail.tmType") {
            let tmNames: string = '';
            for(let counter: number = 0; counter < e.data.length; counter++) {
                const index = this.context.enums?.tmTypes.findIndex(value => value.id === e.data[counter]);
                if(index !== undefined || index !== -1) {
                    tmNames += this.context.enums?.tmTypes[index!].name ?? '';
                }
                if((counter + 1) < e.data.length) {
                    tmNames += ", ";
                }
            }
            return tmNames;
        }
        if(e.field === "notice.detail.subResource")
            return this.context.enums!.subResources[e.data]?.name ?? '';
        if(e.field === "notice.detail.permitType")
            return this.context.enums?.permitTypes[e.data]?.name ?? '';
        if(e.field === "notice.detail.permitStatus")
            return this.context.enums?.permitStates[e.data]?.name ?? '';
        if(e.field === "notice.detail.uploadDate" || e.field === "notice.detail.startDate" || e.field === "notice.detail.endDate" || e.field === "notice.detail.submissionDate")
            return new Intl.DateTimeFormat('en-GB').format(e.data);
        return e.data
    }

    private export_Click(): void {
        this.m_datatableRef.current?.exportCSV({selectionOnly: false})
    }

    private registrations_Click(): void {
        this.props.navigate('/registrations');
    }

    private contacts_Click(): void {
        this.props.navigate(`/contacts`);
    }

    private safedigs_Click(): void {
        this.props.navigate(`/safedigs`);
    }

    private table_onSelectionChange(selection: NoticeRow | NoticeRow[] | undefined): void {

        this.safeSetState((draft: State) =>
            draft.selectedRow = selection as NoticeRow | undefined);

    }

    private async filter_onSelectionChange(newSelection: MNullable<number>): Promise<void> {
        this.m_filter = newSelection ?? 2;
        await this.page_onLoadData();
    }

    private async page_onLoadData(): Promise<void> {
        const listResult = await this.m_noticeClient.callWithReply(
            NoticeReplyMulti, (client) => client.listNotices(this.m_filter)
        );

        listResult.throwIfFailed();

        this.safeSetState((draft: State) => {
            draft.table.rowData = listResult.reply!.notices
                                                   .map((w: Notice) => {
                                                       return {notice: w} as NoticeRow;
                                                   });
        });
    }

    private getToolbarTemplate(): ReactElement<MToolbar> {
        return (
            <React.Fragment>
                <MToolbar>
                    <MButton label="Add"
                             color="success"
                             icon={MNewIconName}
                             iconOnly={false}
                             disabled={false}
                             onClick={this.new_Click}/>
                    <MSpacer/>
                    <MButton label="Open"
                             icon={MOpenIconName}
                             iconOnly={false}
                             disabled={this.isOpenButtonDisabled}
                             onClick={this.open_Click}/>
                    <MSpacer/>
                    <MButton label="Registrations"
                             color="help"
                             icon={GotoIconName}
                             iconOnly={false}
                             disabled={false}
                             onClick={this.registrations_Click}/>
                    <MSpacer/>
                    <MButton label="Contacts"
                             color="help"
                             icon={'pi pi-phone'}
                             iconOnly={false}
                             disabled={false}
                             onClick={this.contacts_Click}/>
                    <MSpacer/>
                    <MButton label="Safe Digs"
                             color="help"
                             icon={GotoIconName}
                             iconOnly={false}
                             disabled={false}
                             onClick={this.safedigs_Click}/>
                    <MSpacer/>
                    <MButton label="Export"
                             icon={ExcelIconName}
                             iconOnly={false}
                             disabled={false}
                             onClick={this.export_Click}/>
                    <MSpacer/>
                </MToolbar>
            </React.Fragment>
        );
    }

    private startDateTemplate = (rowData: NoticeRow): string => {
        if(rowData.notice.detail!.startDate != null) {
            try {
                return rowData.notice.detail!.startDate.toLocaleDateString();
            } catch {
                return '';
            }
        }
        return '';
    };

    private endDateTemplate = (rowData: NoticeRow): string => {
        if(rowData.notice.detail!.endDate != null) {
            try {
                return rowData.notice.detail!.endDate.toLocaleDateString();
            } catch {
                return '';
            }
        }
        return '';
    };

    private submissionDateTemplate = (rowData: NoticeRow): string => {
        if(rowData.notice.detail!.submissionDate != null) {
            try {
                return rowData.notice.detail!.submissionDate.toLocaleDateString();
            } catch {
                return '';
            }
        }
        return '';
    };

    private tmTypeTemplate = (rowData:NoticeRow) : string => {
        let tmNames : string = "";
        for(let counter: number = 0; counter < rowData.notice.detail!.tmType.length; counter++)
        {
            const index = this.context.enums?.tmTypes.findIndex(value => value.id === rowData.notice.detail!.tmType[counter]);

            if(index !== undefined || index !== -1) {
                tmNames += this.context.enums?.tmTypes[index!].name ?? '';
            }

            if((counter + 1) < rowData.notice.detail!.tmType.length)
            {
                tmNames += ", ";
            }
        }

        return tmNames;
    }

    private subResourceTemplate = (rowData:NoticeRow) : string => {
        const index = this.context.enums?.subResources.findIndex(value => value.id === rowData.notice.detail!.subResource);

        if(index !== undefined || index !== -1) {
            return this.context.enums?.subResources[index!].name ?? '';
        }

        return '';
    }

    private permitTypeTemplate = (rowData:NoticeRow) : string => {
        const index = this.context.enums?.permitTypes.findIndex(value => value.id === rowData.notice.detail!.permitType);

        if(index !== undefined || index !== -1) {
            return this.context.enums?.permitTypes[index!].name ?? '';
        }

        return '';
    }

    private permitStatusTemplate = (rowData:NoticeRow) : string => {
        const index = this.context.enums?.permitStates.findIndex(value => value.id === rowData.notice.detail!.permitStatus);

        if(index === undefined || index === -1) {
            return '';
        }

        return this.context.enums?.permitStates[index!].name ?? '';
    }

    private permitFileStatusTemplate(rowData: NoticeRow): ReactElement {
        return <StatusIndicator size={25} status={rowData.notice.permitFileState}/>;
    }

    private tmFileStatusTemplate(rowData: NoticeRow): ReactElement {
        const tmPlanRequiredStates = [0,1,2,3,4,5,6,7];
        const tmRequired = tmPlanRequiredStates.some(item => rowData.notice.detail!.tmType.includes(item));
        return <StatusIndicator size={25} status={rowData.notice.tmFileState} notRequired={!tmRequired}/>;
    }

    private dateFilterTemplate = (options: any) => {
        return <Calendar value={options.value}
                         onChange={(e: any) => options.filterApplyCallback(e.value, options.index)}
                         dateFormat="dd/mm/yy"
                         placeholder="dd/mm/yyyy"
                         mask="99/99/9999"/>;
    };

    private tmTypeFilterTemplate = (options: any) => {
        if(this.context.enums === null) {
            return <div></div>;
        }

        const itemList: MDropDownItem<number>[] = (
            this.context.enums!.tmTypes
                               .map((enumValue) => {
                                   return {label: enumValue.name, value: enumValue.id};
                               })
        );

        return (
            <MMultiDropDown id="tmTypeFilter"
                            items={itemList}
                            disabled={false}
                            onChange={(selection: number[]) => options.filterApplyCallback(selection)}/>
        );
    }

    private subResourceFilterTemplate = (options: any) => {
        if(this.context.enums === null) {
            return <div></div>;
        }

        const itemList: MDropDownItem<number>[] = (
            this.context.enums!.subResources
                               .map((enumValue) => {
                                   return {label: enumValue.name, value: enumValue.id};
                               })
        );

        return (
            <MMultiDropDown id="subResourceFilter"
                            items={itemList}
                            disabled={false}
                            onChange={(selection: number[]) => options.filterApplyCallback(selection)}/>
        );
    }

    private permitTypeFilterTemplate = (options: any) => {
        if(this.context.enums === null) {
            return <div></div>;
        }

        const itemList: MDropDownItem<number>[] = (
            this.context.enums!.permitTypes
                               .map((enumValue) => {
                                   return {label: enumValue.name, value: enumValue.id};
                               })
        );

        return (
            <MMultiDropDown id="permitTypeFilter"
                            items={itemList}
                            disabled={false}
                            onChange={(selection: number[]) => options.filterApplyCallback(selection)}/>
        );
    }

    private permitStatusFilterTemplate = (options: any) => {
        if(this.context.enums === null) {
            return <div></div>;
        }

        const itemList: MDropDownItem<number>[] = (
            this.context.enums!.permitStates
                               .map((enumValue) => {
                                   return {label: enumValue.name, value: enumValue.id};
                               })
        );

        return (
            <MMultiDropDown id="permitStateFilter"
                            items={itemList}
                            disabled={false}
                            onChange={(selection: number[]) => options.filterApplyCallback(selection)}/>
        );
    }

    public render(): ReactElement {
        //The rule parameter needs to be in the format 'custom_[fieldName]
        FilterService.register('custom_notice.detail.tmType', (value: Array<number>, filters: Array<number>) => {
            if(filters === null || filters.length === 0) return true;
            return filters.some(item => value.includes(item));
        });


        return (
            <MPage title="Notices"
                   locked={this.state.page.locked}
                   toolbar={this.getToolbarTemplate()}
                   onLoadData={this.page_onLoadData}>

                    <MDropDown<number> id={"filterSelect"}
                                       disabled={false}
                                       items={[
                                           { label: "Open Notices", value: 0 },
                                           { label: "Missing Registrations", value: 1 },
                                           { label: "Requested Notices", value: 3 },
                                           { label: "All Notices", value: 2 }
                                       ]}
                                       initialValue={0}
                                       onChange={this.filter_onSelectionChange}
                    />
                <MTable innerRef={this.m_datatableRef}
                        rowKey="notice.detail.id"
                        rowData={this.state.table.rowData}
                        filters={this.state.table.filters}
                        onSelectionChange={this.table_onSelectionChange}
                        sortMode={'multiple'}
                        multiSortMeta={[{field: 'notice.header.odinId', order: 1}]}
                        exportFunction={this.exportFunction}
                        exportName={'NoticesExport'}>

                    <Column field="notice.header.odinId"
                            header="ID"
                            filter={true}
                            sortable={true}
                            style={{width: '10%'}}/>
                    <Column field="notice.detail.tmType"
                            header="TM Type"
                            filter={true}
                            filterElement={this.tmTypeFilterTemplate}
                            showClearButton={false}
                            showFilterMenu={false}
                            sortable={true}
                            body={this.tmTypeTemplate}
                            style={{width: '12%'}}/>
                    <Column field="notice.detail.address1"
                            header="Address"
                            filter={true}
                            sortable={true}
                            style={{width: '10%'}}/>
                    <Column field="notice.detail.startDate"
                            header="Start Date"
                            dataType="date"
                            filter={true}
                            filterElement={this.dateFilterTemplate}
                            sortable={true}
                            body={this.startDateTemplate}
                            style={{width: '12%'}}/>
                    <Column field="notice.detail.endDate"
                            header="End Date"
                            dataType="date"
                            filter={true}
                            filterElement={this.dateFilterTemplate}
                            sortable={true}
                            body={this.endDateTemplate}
                            style={{width: '12%'}}/>
                    <Column field="notice.detail.subResource"
                            header="Sub Resource"
                            filter={true}
                            filterElement={this.subResourceFilterTemplate}
                            showClearButton={false}
                            showFilterMenu={false}
                            sortable={true}
                            body={this.subResourceTemplate}
                            style={{width: '18%'}}/>
                    <Column field="notice.detail.permitNumber"
                            header="Permit Number"
                            filter={true}
                            sortable={true}
                            style={{width: '18%'}}/>
                    <Column field="notice.detail.permitType"
                            header="Permit Type"
                            filter={true}
                            filterElement={this.permitTypeFilterTemplate}
                            showClearButton={false}
                            showFilterMenu={false}
                            sortable={true}
                            body={this.permitTypeTemplate}
                            style={{width: '12%'}}/>
                    <Column field="notice.detail.submissionDate"
                            header="Submission Date"
                            dataType="date"
                            filter={true}
                            filterElement={this.dateFilterTemplate}
                            sortable={true}
                            body={this.submissionDateTemplate}
                            style={{width: '12%'}}/>
                    <Column field="notice.detail.permitStatus"
                            header="Permit Status"
                            filter={true}
                            filterElement={this.permitStatusFilterTemplate}
                            showClearButton={false}
                            showFilterMenu={false}
                            sortable={true}
                            body={this.permitStatusTemplate}
                            style={{width: '12%'}}/>
                    <Column field="notice.permitFileState"
                            header="Permit"
                            filter={false}
                            body={this.permitFileStatusTemplate}
                            style={{width: '5%'}}/>
                    <Column field="notice.tmFileState"
                            header="TM"
                            filter={false}
                            body={this.tmFileStatusTemplate}
                            style={{width: '5%'}}/>
                </MTable>
            </MPage>
        );
    }
}

export default withMsal(WithRouter(ListNoticesPage));


